import {IconProps} from './types';

function AiAgentSendIcon({stroke = 'white', width = 16, height = 16, className}: IconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
            className={className}
            aria-hidden
        >
            <path
                d="M8 12.667V3.333"
                stroke={stroke}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4 7.333L8 3.333L12 7.333"
                stroke={stroke}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default AiAgentSendIcon;
